
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'CustomersHeader'
})
export default class extends Vue {
  @Prop({ required: true }) private hasResults!: boolean
  @Prop({ required: true }) private exporting!: boolean

  handleExportCommand(command: string) {
    if (command === 'excel') {
      this.$emit('export')
    } else if (command === 'csv') {
      this.$emit('exportCSV')
    }
  }
}
